import React from 'react';
import './App.css';
import Home from './components/home/Home';

const App = () => {
    return (
        <div>
            <Home/>
        </div>
    )
}

export default App;